import html2canvas from 'html2canvas';

const exportAsPng = async (htmlRef: HTMLElement, _clientLogoUrl?: string) => {
  // Store original styles including transform
  const originalOverflow = htmlRef.style.overflow;
  const originalHeight = htmlRef.style.height;
  const originalMaxHeight = htmlRef.style.maxHeight;
  const originalTransform = htmlRef.style.transform;

  // Temporarily remove scroll, expand to full content height, and remove transform
  htmlRef.style.overflow = 'visible';
  htmlRef.style.height = 'auto';
  htmlRef.style.maxHeight = 'none';
  htmlRef.style.transform = 'none'; // Remove scale transform for capture

  // Dispatch event to notify components that capture is starting
  window.dispatchEvent(new Event('html2canvas-capture-start'));

  // Wait a bit for components to adjust their styles and images to settle
  await new Promise((resolve) => setTimeout(resolve, 300));

  const canvas = await html2canvas(htmlRef, {
    scale: 2, // Higher quality
    useCORS: true, // Use CORS - requires server to send Access-Control-Allow-Origin header
    allowTaint: false,
    logging: false,
    scrollY: -window.scrollY,
    scrollX: -window.scrollX,
    windowWidth: htmlRef.scrollWidth,
    windowHeight: htmlRef.scrollHeight,
  });

  // Dispatch event to notify components that capture is complete
  window.dispatchEvent(new Event('html2canvas-capture-end'));

  // Restore original styles including transform
  htmlRef.style.overflow = originalOverflow;
  htmlRef.style.height = originalHeight;
  htmlRef.style.maxHeight = originalMaxHeight;
  htmlRef.style.transform = originalTransform;

  // Convert canvas to blob
  canvas.toBlob((blob) => {
    if (blob) {
      // Create download link
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `daily-dish-report-${new Date().getTime()}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  });
};

export default exportAsPng;
